'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Skeleton } from '../../skeleton';

import styles from './SelectableList.Skeleton.module.scss';

export type SelectableListSkeletonProps = BaseComponentProps & {
  items: number;
};

function SelectableListSkeleton({
  style,
  className,
  items,
}: SelectableListSkeletonProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      {[...Array(items)].map((_, index) => (
        <div className={styles['row']} key={index}>
          <div className={styles['item-wrapper']}>
            <Skeleton className={styles['item']} />
          </div>
          <Skeleton className={styles['legend']} />
        </div>
      ))}
    </div>
  );
}

export { SelectableListSkeleton };
